import { Component } from '@angular/core';
import { filterUndefined, fixPjpegAvatar, trackByRef } from 'src/app/lego-utils';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Roles } from 'src/app/models/domain';
import { AdminService, SessionService } from 'src/app/state';

@Component({
  selector: 'em-profile-dropdown',
  styleUrls: ['./profile-dropdown.component.less'],
  templateUrl: './profile-dropdown.component.html',
  standalone: false,
})
export class ProfileDropdownComponent {
  public readonly trackByRef = trackByRef;
  public readonly fixPjpegAvatar = fixPjpegAvatar;
  public listOfRoles = Object.values(Roles);

  public userName$ = this.sessionService.userName$;
  public userJobTitle$ = this.sessionService.userJobTitle$;
  public imageSrc$ = this.sessionService.userImageSrc$;
  public role$ = this.sessionService.role$;
  public isAdmin$ = this.sessionService.userShortName$.pipe(
    filterUndefined(),
    switchMap((id) => this.adminService.get(id)),
    map(() => true),
    catchError(() => of(false))
  );

  public constructor(
    private readonly sessionService: SessionService,
    private readonly adminService: AdminService
  ) {}

  public toggleRole(role: string) {
    this.sessionService.setCurrentRole(role);
  }
}
